import { useLogger } from '#imports'
import useLayeredContent from './useLayeredContent'
import type { Page } from '../../utils/pages-config'
import { normalizeSeo } from '../../utils/seo-schema'

export function useContentPage() {
    const { queryAll, queryBySlug } = useLayeredContent()
    const logger = useLogger()

    async function getPages() {
        return await queryAll<Page>('pages')
    }

    async function getPageBySeoName(seoName: string) {
        const page = await queryBySlug<Page>('pages', seoName)
        if (!page) return null
        return {
            ...page,
            seo: normalizeSeo(page.seo, value => logger.error(`Malformed SEO on page "${seoName}":`, value)),
        }
    }

    return { getPages, getPageBySeoName }
}
